// No push on web, match interface with empty functions

const push = {
  getToken: Promise.resolve,
  requestPermission: Promise.resolve,
  hasPermission: Promise.resolve,
  configure: () => null,
}

export default push
